import { render, staticRenderFns } from "./TencentCreative.vue?vue&type=template&id=a972c4d6&scoped=true"
import script from "./TencentCreative.vue?vue&type=script&lang=js"
export * from "./TencentCreative.vue?vue&type=script&lang=js"
import style0 from "./TencentCreative.vue?vue&type=style&index=0&id=a972c4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a972c4d6",
  null
  
)

export default component.exports